import Badge1 from './Badge1.png';
import Badge2 from './Badge2.png';
import Badge3 from './Badge3.png';
import Badge4 from './Badge4.png';
import Badge5 from './Badge5.png';
import Badge6 from './Badge6.png';
import Badge7 from './Badge7.png';
import Badge8 from './Badge8.png';
import Badge9 from './Badge9.png';
import Badge10 from './Badge10.png';
import kidScreen from './kidScreen.png';
import parentScreen from './parentScreen.png';
import megaman from './megaman.gif';

export default {
  Badge1,
  Badge2,
  Badge3,
  Badge4,
  Badge5,
  Badge6,
  Badge7,
  Badge8,
  Badge9,
  Badge10,
  parentScreen,
  kidScreen,
  megaman,
};
